import React from "react";

const HeadTag = () => {
  return (
    <>
      <title>Cactus cloud - Cactus.cloud</title>
      <meta
        name="description"
        content="Optimize your Project's Infrastructure in Minutes - Optimize the management of your IT infrastructure with our platform, offering an agile, secure, and scalable solution. Gain greater control over your technological resources and maximize your savings."
      />
      <meta
        name="keywords"
        content="microservices, domains, environments, apps, resources, frontends, monolithic, cloud, cactus cloud, aws, amazon Cactus.cloud, Cactus cloud, Cactus.cloud"
      ></meta>
      <meta
        property="og:image"
        content="https://c4c7us.com/assets/images/landing-pages-images/logo192.png"
      ></meta>
      <meta
        name="google-site-verification"
        content="uxiEoSYNzAQXxMgOR2aHTuEuqWGPub2nKIPcnriafec"
      />
      <meta
        name="google-site-verification"
        content="LDFpkbRaAYXgpQ_Gi9WEEkmsBpytQZqcoRSWXfAFIoQ"
      />
    </>
  );
};

export default HeadTag;
